import { useMutation } from "@apollo/client"
import { STORE_EDIT } from "../queries/storeEdit"
import { useToast } from "@/hooks/use-toast"

export interface StoreEditInput {
  id: number
  name: string
  description?: string
  logo?: string
  cover?: string
  phone: string
  email: string
  active?: number
  clasificationId?: number
  client?: string
  inChargePerson?: string
  siteUrl?: string
  facebookUrl?: string
  instagramUrl?: string
  youtubeUrl?: string
  twitterUrl?: string
  levelId?: number
  tournamentDays?: number[]
  storeGames?: number[]
  tournamentTypes?: Array<{
    typeId: number
    quantity: number
  }>
  address: {
    id?: number
    name: string
    address: string
    countryId: number
    regionId: number
    locationId: number
  }
}

export const useStoreEdit = () => {
  const { toast } = useToast()

  const [storeEditMutation, { loading, error }] = useMutation(STORE_EDIT, {
    refetchQueries: ["StoreList"],
    onCompleted: (data) => {
      if (data.StoreEdit.status.success) {
        toast({
          title: "Tienda actualizada",
          variant: "success",
          description: "Los datos de la tienda han sido actualizados exitosamente",
        })
      } else {
        toast({
          title: "Error",
          description: data.StoreEdit.status.detail,
          variant: "destructive",
        })
      }
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  const editStore = async (input: StoreEditInput) => {
    try {
      const result = await storeEditMutation({
        variables: { input },
      })
      return result.data
    } catch (error) {
      console.error("Store edit error:", error)
      throw error
    }
  }

  return {
    editStore,
    loading,
    error,
  }
}
